import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#000000',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontStyle: 'bold',
    },
    description: {
        width: '80%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
    },
    qtd: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
    },
});

const OrderServiceTableRow = ({items}) => {
    return (
        <Fragment>
            {items.map( item => {
                let quant = (item?.qtd) ? item.qtd : 0;
                quant = (quant === 0 && item?.needed) ? item?.needed : 0;

                return (
                <View style={styles.row} key={(item?.item?._id) ? item?.item?._id : 0}>
                    <Text style={styles.description}>{(item?.item?.name) ? item?.item?.name : ''}</Text>
                    <Text style={styles.qtd}>{quant}</Text>
                    <Text style={styles.qtd}></Text>
                </View>
                )
            })}
        </Fragment> )
};
  
export default OrderServiceTableRow